"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var WalletSelector_1 = __importDefault(require("./WalletSelector"));

var Create_1 = __importDefault(require("./Create"));

var Confirm_1 = __importDefault(require("./Create/Confirm"));

var Backup_1 = __importDefault(require("./Create/Backup"));

var AddFunds_1 = __importDefault(require("./Create/AddFunds"));

var Input_1 = __importDefault(require("./Input"));

var Select_1 = __importDefault(require("./Select"));

var qrImage = __importStar(require("qr-image"));

var wallets_1 = require("../../wallets");

var wallet_1 = require("../../selector/wallet");

var wallet_2 = require("../../actions/wallet");

var Svg_1 = __importDefault(require("../Svg"));

var LedgerConnector_1 = __importDefault(require("./LedgerConnector"));

var NotSupport_1 = __importDefault(require("./NotSupport"));

var i18n_1 = __importDefault(require("../../i18n"));

var Wallet = function (_super) {
  __extends(Wallet, _super);

  function Wallet(props) {
    var _this = _super.call(this, props) || this;

    var _a = _this.props,
        defaultWalletType = _a.defaultWalletType,
        translations = _a.translations,
        dispatch = _a.dispatch,
        customLocalWallet = _a.customLocalWallet,
        unit = _a.unit,
        decimals = _a.decimals;
    dispatch(wallet_2.setTranslations(translations || i18n_1.default));

    if (customLocalWallet) {
      dispatch(wallet_2.initCustomLocalWallet(customLocalWallet));
    }

    if (unit && typeof decimals === "number") {
      dispatch(wallet_2.setUnit(unit, decimals));
    }

    var selectedWalletType;
    var lastSelectedWalletType = window.localStorage.getItem("HydroWallet:lastSelectedWalletType");

    if (defaultWalletType) {
      selectedWalletType = defaultWalletType;
    } else if (lastSelectedWalletType) {
      selectedWalletType = lastSelectedWalletType;
    } else {
      selectedWalletType = wallets_1.defaultWalletTypes[0];
    }

    dispatch(wallet_2.selectWalletType(selectedWalletType));
    _this.state = {
      password: "",
      processing: false,
      checkbox: false
    };
    return _this;
  }

  Wallet.prototype.componentDidMount = function () {
    var _a = this.props,
        nodeUrl = _a.nodeUrl,
        LocalWallet = _a.LocalWallet;

    if (nodeUrl) {
      wallets_1.setGlobalNodeUrl(nodeUrl);
      LocalWallet.setNodeUrl(nodeUrl);
    }

    if (document.readyState === "complete") {
      this.loadExtensitonWallet();
    } else {
      window.addEventListener("load", this.loadExtensitonWallet.bind(this));
    }
  };

  Wallet.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        selectedAccount = _a.selectedAccount,
        isShowWalletModal = _a.isShowWalletModal,
        dispatch = _a.dispatch,
        translations = _a.translations;

    if (!isShowWalletModal && isShowWalletModal !== prevProps.isShowWalletModal && selectedAccount) {
      var wallet = selectedAccount.get("wallet");
      dispatch(wallet_2.selectWalletType(wallet.type()));
    }

    if (translations && translations !== prevProps.translations) {
      dispatch(wallet_2.setTranslations(translations));
    }
  };

  Wallet.prototype.loadExtensitonWallet = function () {
    var _a = this.props,
        dispatch = _a.dispatch,
        walletTypes = _a.walletTypes,
        loadWalletActions = _a.loadWalletActions;
    var types = walletTypes ? walletTypes : wallets_1.defaultWalletTypes;
    types.map(function (type) {
      var loadWalletAction = loadWalletActions ? loadWalletActions[type] : null;
      dispatch(wallet_2.loadWallet(type, loadWalletAction));
    });
  };

  Wallet.prototype.render = function () {
    var _a = this.props,
        isShowWalletModal = _a.isShowWalletModal,
        dispatch = _a.dispatch,
        walletTranslations = _a.walletTranslations,
        selectedWalletType = _a.selectedWalletType;
    return React.createElement("div", {
      className: "HydroSDK-wallet"
    }, React.createElement("div", {
      className: "HydroSDK-container",
      hidden: !isShowWalletModal
    }, React.createElement("div", {
      className: "HydroSDK-backdrop",
      onClick: function onClick() {
        return dispatch(wallet_2.hideWalletModal());
      }
    }), React.createElement("div", {
      className: "HydroSDK-dialog"
    }, React.createElement("div", {
      className: "HydroSDK-title"
    }, walletTranslations.dialogTitle), walletTranslations.dialogSubtitle && React.createElement("div", {
      className: "HydroSDK-desc"
    }, walletTranslations.dialogSubtitle), React.createElement("div", {
      className: "HydroSDK-fieldGroup"
    }, React.createElement("div", {
      className: "HydroSDK-label"
    }, walletTranslations.selectWallet), React.createElement(Select_1.default, {
      options: this.getWalletsOptions(),
      selected: selectedWalletType
    })), this.renderStepContent(), this.renderUnlockForm(), this.renderDeleteForm(), React.createElement("button", {
      className: "HydroSDK-button HydroSDK-closeButton",
      onClick: function onClick() {
        return dispatch(wallet_2.hideWalletModal());
      }
    }, walletTranslations.close))));
  };

  Wallet.prototype.renderStepContent = function () {
    var _a = this.props,
        extensionWalletSupported = _a.extensionWalletSupported,
        accounts = _a.accounts,
        step = _a.step,
        walletTranslations = _a.walletTranslations,
        selectedWalletType = _a.selectedWalletType;

    switch (step) {
      case wallet_2.WALLET_STEPS.SELECT:
      case wallet_2.WALLET_STEPS.DELETE:
        if (selectedWalletType === wallets_1.WalletConnectWallet.TYPE) {
          var account = accounts.get(wallets_1.WalletConnectWallet.TYPE);
          if (account.get("isLocked")) return this.renderQrImage();
        } else if (selectedWalletType === wallets_1.Ledger.TYPE) {
          return React.createElement(LedgerConnector_1.default, null);
        } else if (selectedWalletType === wallets_1.ExtensionWallet.TYPE && !extensionWalletSupported) {
          return React.createElement(NotSupport_1.default, {
            iconName: "metamask",
            title: walletTranslations.installMetamask,
            desc: walletTranslations.installMetamaskDesc
          });
        }

        return React.createElement(WalletSelector_1.default, {
          walletType: selectedWalletType
        });

      case wallet_2.WALLET_STEPS.CREATE:
        return React.createElement(Create_1.default, null);

      case wallet_2.WALLET_STEPS.CREATE_CONFIRM:
        return React.createElement(Confirm_1.default, null);

      case wallet_2.WALLET_STEPS.BACKUP:
        return React.createElement(Backup_1.default, null);

      case wallet_2.WALLET_STEPS.ADD_FUNDS:
        return React.createElement(AddFunds_1.default, null);

      case wallet_2.WALLET_STEPS.IMPORT:
        return React.createElement(Create_1.default, {
          isRecovery: true
        });

      default:
        return null;
    }
  };

  Wallet.prototype.renderQrImage = function () {
    var accounts = this.props.accounts;
    var wallet = accounts.get(wallets_1.WalletConnectWallet.TYPE).get("wallet");
    var connector = wallet.connector;
    return React.createElement("div", {
      className: "HydroSDK-qr-image"
    }, React.createElement("div", {
      className: "HydroSDK-qr-image-bg",
      dangerouslySetInnerHTML: {
        __html: qrImage.imageSync(connector.uri, {
          type: "svg"
        }).toString()
      }
    }));
  };

  Wallet.prototype.renderUnlockForm = function () {
    var _this = this;

    var _a = this.state,
        password = _a.password,
        processing = _a.processing;
    var _b = this.props,
        selectedAccount = _b.selectedAccount,
        step = _b.step,
        walletTranslations = _b.walletTranslations,
        selectedWalletType = _b.selectedWalletType,
        LocalWallet = _b.LocalWallet;

    if (selectedWalletType !== LocalWallet.TYPE || step !== wallet_2.WALLET_STEPS.SELECT && step !== wallet_2.WALLET_STEPS.DELETE || !selectedAccount || !selectedAccount.get("isLocked")) {
      return null;
    }

    return React.createElement(React.Fragment, null, React.createElement(Input_1.default, {
      label: walletTranslations.password,
      text: password,
      handleChange: function handleChange(password) {
        return _this.setState({
          password: password
        });
      }
    }), React.createElement("button", {
      className: "HydroSDK-button HydroSDK-submitButton HydroSDK-featureButton",
      disabled: processing,
      onClick: function onClick() {
        return _this.handleUnlock(selectedAccount);
      }
    }, processing ? React.createElement("i", {
      className: "HydroSDK-fa fa fa-spinner fa-spin"
    }) : null, " ", walletTranslations.unlock));
  };

  Wallet.prototype.renderDeleteForm = function () {
    var _this = this;

    var _a = this.state,
        checkbox = _a.checkbox,
        processing = _a.processing;
    var _b = this.props,
        selectedAccount = _b.selectedAccount,
        step = _b.step,
        walletTranslations = _b.walletTranslations,
        selectedWalletType = _b.selectedWalletType,
        LocalWallet = _b.LocalWallet;

    if (!selectedAccount || selectedAccount.get("isLocked") || selectedAccount.get("wallet").type() !== LocalWallet.TYPE || step !== wallet_2.WALLET_STEPS.DELETE || selectedWalletType !== LocalWallet.TYPE) {
      return null;
    }

    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "HydroSDK-hint"
    }, React.createElement("div", {
      className: "HydroSDK-hintTitle"
    }, React.createElement("i", {
      className: "HydroSDK-fa fa fa-bullhorn"
    }), walletTranslations.headsUp), React.createElement("span", null, walletTranslations.deleteTip), React.createElement("div", {
      className: "HydroSDK-checkboxDiv " + (checkbox ? "checked" : ""),
      onClick: function onClick() {
        return _this.setState({
          checkbox: !checkbox
        });
      }
    }, React.createElement("div", {
      className: "HydroSDK-checkbox"
    }, React.createElement("i", {
      className: "fa fa-check"
    })), walletTranslations.deleteConfirm)), React.createElement("button", {
      className: "HydroSDK-button HydroSDK-submitButton HydroSDK-featureButton",
      disabled: processing || !checkbox,
      onClick: function onClick() {
        return _this.handleDelete(selectedAccount);
      }
    }, processing ? React.createElement("i", {
      className: "HydroSDK-fa fa fa-spinner fa-spin"
    }) : null, " ", walletTranslations.delete));
  };

  Wallet.prototype.handleDelete = function (selectedAccount) {
    return __awaiter(this, void 0, void 0, function () {
      var e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2, 3, 4]);

            this.setState({
              processing: true
            });
            return [4, this.props.dispatch(wallet_2.deleteBrowserWalletAccount(selectedAccount))];

          case 1:
            _a.sent();

            return [3, 4];

          case 2:
            e_1 = _a.sent();
            alert(e_1);
            return [3, 4];

          case 3:
            this.setState({
              processing: false
            });
            return [7];

          case 4:
            return [2];
        }
      });
    });
  };

  Wallet.prototype.handleUnlock = function (selectedAccount) {
    return __awaiter(this, void 0, void 0, function () {
      var password, e_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2, 3, 4]);

            password = this.state.password;
            this.setState({
              processing: true
            });
            return [4, this.props.dispatch(wallet_2.unlockBrowserWalletAccount(selectedAccount, password))];

          case 1:
            _a.sent();

            return [3, 4];

          case 2:
            e_2 = _a.sent();
            alert(e_2);
            return [3, 4];

          case 3:
            this.setState({
              processing: false
            });
            return [7];

          case 4:
            return [2];
        }
      });
    });
  };

  Wallet.prototype.getWalletsOptions = function () {
    var _a = this.props,
        dispatch = _a.dispatch,
        menuOptions = _a.menuOptions;

    if (!menuOptions) {
      menuOptions = [{
        value: wallets_1.ExtensionWallet.TYPE,
        component: React.createElement("div", {
          className: "HydroSDK-optionItem"
        }, React.createElement(Svg_1.default, {
          name: "metamask"
        }), wallets_1.ExtensionWallet.LABEL),
        onSelect: function onSelect(option) {
          wallets_1.ExtensionWallet.enableBrowserExtensionWallet();
          dispatch(wallet_2.setWalletStep(wallet_2.WALLET_STEPS.SELECT));
          dispatch(wallet_2.selectWalletType(option.value));
        }
      }, {
        value: wallets_1.Ledger.TYPE,
        component: React.createElement("div", {
          className: "HydroSDK-optionItem"
        }, React.createElement(Svg_1.default, {
          name: "ledger"
        }), wallets_1.Ledger.LABEL),
        onSelect: function onSelect(option) {
          dispatch(wallet_2.setWalletStep(wallet_2.WALLET_STEPS.SELECT));
          dispatch(wallet_2.selectWalletType(option.value));
        }
      }, {
        value: wallets_1.WalletConnectWallet.TYPE,
        component: React.createElement("div", {
          className: "HydroSDK-optionItem"
        }, React.createElement(Svg_1.default, {
          name: "WalletConnect"
        }), wallets_1.WalletConnectWallet.LABEL),
        onSelect: function onSelect(option) {
          dispatch(wallet_2.setWalletStep(wallet_2.WALLET_STEPS.SELECT));
          dispatch(wallet_2.selectWalletType(option.value));
        }
      }];
    }

    return menuOptions.concat(this.localWalletOptions());
  };

  Wallet.prototype.localWalletOptions = function () {
    var _a = this.props,
        dispatch = _a.dispatch,
        walletTranslations = _a.walletTranslations,
        LocalWallet = _a.LocalWallet,
        hideLocalWallet = _a.hideLocalWallet;

    if (hideLocalWallet) {
      return [];
    }

    var hydroWalletsCount = LocalWallet.list().length;
    var isEmptyHydroWallet = hydroWalletsCount === 0;
    return [{
      value: LocalWallet.TYPE,
      component: React.createElement("div", {
        className: "HydroSDK-optionItem" + (isEmptyHydroWallet ? " disabled" : "")
      }, React.createElement(Svg_1.default, {
        name: "logo"
      }), LocalWallet.LABEL, " (", hydroWalletsCount, ")"),
      onSelect: function onSelect(option) {
        dispatch(wallet_2.setWalletStep(isEmptyHydroWallet ? wallet_2.WALLET_STEPS.CREATE : wallet_2.WALLET_STEPS.SELECT));
        dispatch(wallet_2.selectWalletType(option.value));
      }
    }, {
      value: wallet_2.WALLET_STEPS.CREATE,
      component: React.createElement("div", {
        className: "HydroSDK-optionItem HydroSDK-walletFeature"
      }, React.createElement(Svg_1.default, {
        name: "create"
      }), walletTranslations.createWallet),
      onSelect: function onSelect() {
        dispatch(wallet_2.setWalletStep(wallet_2.WALLET_STEPS.CREATE));
        dispatch(wallet_2.selectWalletType(LocalWallet.TYPE));
      }
    }, {
      value: wallet_2.WALLET_STEPS.IMPORT,
      component: React.createElement("div", {
        className: "HydroSDK-optionItem HydroSDK-walletFeature"
      }, React.createElement(Svg_1.default, {
        name: "import"
      }), walletTranslations.importWallet),
      onSelect: function onSelect() {
        dispatch(wallet_2.setWalletStep(wallet_2.WALLET_STEPS.IMPORT));
        dispatch(wallet_2.selectWalletType(LocalWallet.TYPE));
      }
    }, {
      value: wallet_2.WALLET_STEPS.DELETE,
      component: React.createElement("div", {
        className: "HydroSDK-optionItem HydroSDK-walletFeature"
      }, React.createElement(Svg_1.default, {
        name: "delete"
      }), walletTranslations.deleteWallet),
      onSelect: function onSelect() {
        dispatch(wallet_2.setWalletStep(wallet_2.WALLET_STEPS.DELETE));
        dispatch(wallet_2.selectWalletType(LocalWallet.TYPE));
      }
    }];
  };

  return Wallet;
}(React.PureComponent);

exports.default = react_redux_1.connect(function (state) {
  var walletState = state.WalletReducer;
  return {
    walletTranslations: walletState.get("walletTranslations"),
    selectedAccount: wallet_1.getSelectedAccount(state),
    accounts: walletState.get("accounts"),
    extensionWalletSupported: walletState.get("extensionWalletSupported"),
    isShowWalletModal: walletState.get("isShowWalletModal"),
    step: walletState.get("step"),
    selectedWalletType: walletState.get("selectedWalletType"),
    LocalWallet: walletState.get("LocalWallet") || wallets_1.HydroWallet
  };
})(Wallet);